// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".el-upload--picture-card{width:5rem;height:5rem;line-height:5rem}.el-upload-list--picture-card .el-upload-list__item{width:5rem;height:5rem}.sortable-ghost{opacity:.5;background:#c8ebfb}.sortable-chosen,.sortable-drag{transform:rotate(5deg)}.sortable-drag{opacity:.8}.el-upload-list--picture-card .el-upload-list__item:hover{cursor:move}", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
